import React from "react";
import { TESTIMONIALS } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import { Quote } from "lucide-react";

export default function Testimonials() {
  const { testimonials = TESTIMONIALS } = useContent();
  return (
    <section className="relative py-24 lg:py-32 bg-[#0d0b09]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-5">
          <span className="divider-line" />
          <span className="text-[11px] tracking-[0.4em] text-[#B87333]">REFERANSLAR</span>
        </div>
        <h2 className="font-serif-display text-[#f5ede1] text-4xl md:text-5xl leading-tight font-light mb-14">
          Müşterilerimizin güveni, en büyük referansımızdır.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="group p-10 border border-[#B87333]/20 bg-[#0a0807] hover:border-[#B87333] transition-colors duration-500 relative"
            >
              <Quote className="w-8 h-8 text-[#B87333]/40 mb-6" />
              <p className="text-[#f5ede1]/90 leading-relaxed text-base italic">“{t.text}”</p>
              <div className="mt-8 pt-6 border-t border-[#B87333]/20">
                <p className="text-[#B87333] font-serif-display text-lg">{t.name}</p>
                <p className="text-[11px] tracking-[0.2em] text-[#a89a85] mt-1">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
